const config = {
    cart: {
        path: 'orders',
    },
    catalog: {
        path: 'catalog',
    },
    demand: {
        path: 'demand',
    },
};
export const cart = config.cart;
export const catalog = config.catalog;
export const demand = config.demand;
export default config;
